export default __webpack_public_path__ + "static/media/jogo_limpo.1c9fc433.png";